import { render, staticRenderFns } from "./Another.vue?vue&type=template&id=61cd6ab1"
import script from "./Another.vue?vue&type=script&lang=js"
export * from "./Another.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61cd6ab1')) {
      api.createRecord('61cd6ab1', component.options)
    } else {
      api.reload('61cd6ab1', component.options)
    }
    module.hot.accept("./Another.vue?vue&type=template&id=61cd6ab1", function () {
      api.rerender('61cd6ab1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Another.vue"
export default component.exports